import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InventoryActivityComponent } from './inventory-activity.component';

@NgModule({
    imports: [CommonModule],
    exports: [InventoryActivityComponent],
    declarations: [InventoryActivityComponent],
    providers: [],
})
export class InventoryActivityModule { }
